<template>
	<div>
		<section class="midsection">
			<div class="slider">
				<div v-if="image" class="slides">
					<div v-if="header" class="slider-content">
						<div class="row">
							<div class="columns column12">
								<h2>{{ header }}</h2>
							</div>
						</div>
					</div>
					<picture v-if="image">
						<source v-if="imageWebp" :srcset="imageWebp" type="image/webp" />
						<source :srcset="image" />
						<img class="slider-image" :src="image" :alt="header" />
					</picture>
				</div>
				<div v-if="content" class="row small-row">
					<div class="columns column12 align-center">
						<div v-parse-links v-html="content" />
					</div>
				</div>
			</div>
			<div class="image-row">
				<div v-if="imageleft" class="columns column6 align-center">
					<picture>
						<source v-if="imageleft.imageWebp" :srcset="imageleft.imageWebp" type="image/webp" />
						<source :srcset="imageleft" />
						<img class="slider-image" :src="imageleft" :alt="imageleft.imageAlt" />
					</picture>
					<div v-parse-links v-html="contentleft" />
				</div>
				<div v-if="imageright" class="columns column6 align-center">
					<picture>
						<source v-if="imageright.imageWebp" :srcset="imageright.imageWebp" type="image/webp" />
						<source :srcset="imageright" />
						<img class="slider-image" :src="imageright" :alt="imageright.imageAlt" />
					</picture>
					<div v-parse-links v-html="contentright" />
				</div>
			</div>
		</section>
		<slot name="bottomSectionContent" />
	</div>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	image: { type: String, default: '' },
	imageWebp: { type: String, default: '' },
	contentleft: { type: String, default: '' },
	contentright: { type: String, default: '' },
	imageleft: { type: String, default: '' },
	imageright: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.midsection {
	padding: 0;
	display: inline-block;
	width: 100%;
}

.image-row {
	.column6:first-child {
		img {
			padding: 70px 50px 0;
		}
	}

	img {
		margin: 20px auto;
	}
}

.slider,
.slider .slides {
	height: auto;
	position: relative;
}

.slider .slides {
	padding-top: 87px;
}

.small-row {
	padding: 25px 0 50px;

	p:first-child,
	:deep(p:first-child) {
		margin-top: 0;
	}
}

.slider-content {
	position: absolute;
	top: 0%;
	left: 0;
	right: 0;
	color: #fff;
	z-index: 2;
	animation: fade-from-bottom 2s ease;

	h2,
	h1 {
		font-size: 118px;
		line-height: 148px;
		color: $footer-background-color;
		text-align: center;
	}

	&.color-orange {
		h1,
		h2,
		h3 {
			color: #d64e30;
		}
	}

	&.color-blue {
		h1,
		h2,
		h3 {
			color: #6689c5;
		}
	}

	&.color-green {
		h1,
		h2,
		h3 {
			color: #0f2d16;
		}
	}
}

@media (max-width: 1180px) {
	.slider-content {
		h1,
		h2 {
			font-size: 50px;
			line-height: 60px;
		}
	}
}

@media (max-width: 960px) {
	.slider-content {
		h1,
		h2 {
			font-size: 42px;
			line-height: 54px;
		}
	}

	.image-row {
		.column6 {
			width: 50%;
			padding: 10px;
		}

		.column6:first-child {
			img {
				padding: 15px;
			}
		}
	}
}

@media (max-width: 720px) {
	.slider {
		.slides {
			padding-top: 24px;
		}
	}

	.slider-content {
		h1,
		h2 {
			font-size: 38px;
			line-height: 42px;
		}
	}
}
</style>
